module.exports = __webpack_public_path__ + "static/media/t3.4dd3c2ae.png";